import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-link-out',
	templateUrl: './icon-link-out.component.svg',
})
export class IconLinkOutComponent {}
